/*
 * @Descripttion: http 接口
 */
import axios from 'axios';
import {
  API_BASE_URL,
  HTTP_TIMEOUT,
  NOT_ALERT_CODE_LIST,
  ERROR_CODES,
} from '../const/constants.js';

const { QCLogin } = window;
const search = new URLSearchParams(location.search);
const isDev = search.get('dev');
const service = axios.create({
  timeout: HTTP_TIMEOUT,
  withCredentials: true
});

service.interceptors.request.use(
  config => config,
  error => Promise.reject(error),
);

service.interceptors.response.use(
  (response, res) => {
    const { code } = response.data;
    switch (code) {
      case ERROR_CODES.NO_PERMISSION:
        console.log('error! 您无权限访问');
        break;
      case ERROR_CODES.UNKNOWN_ERROR:
        console.log('error! ' + message);
        break;
      case ERROR_CODES.SENSITIVE_IMAGE:
        console.log('图片包含敏感信息，请更换图片。');
        return { error: true, isImageError: true, message: '图片包含敏感信息，请更换图片。' };
        break;
      default:
        break;
    }
    return response;
  },
  error => Promise.reject(error),
);

// check response code
function checkResponseStatus(response) {
  if (response.status === 200) {
    if (response.data.code === 0) {
      return {
        ...response.data.data.Response,
        auditData: response.data.auditData,
      };
    } else {
      return { code: response.data.code, auditData: response.data.auditData, error: true, message: response.data.message };
    }
  }
  return response;
}

function catchError(error) {
  console.log(`服务器访问出错。\n${error.message}`);
  if (error.message === 'canceled') {
    return undefined;
  }
  return { error: true, message: `服务器访问出错。\n${error.message}` };
}

// check server response
function checkResponseCode(response, checkLogin = true) {
  const { Error, error, code, auditData } = response;
  // 处理云API异常
  if (Error) {
    const {
      Code, Message,
    } = Error;
    if (!NOT_ALERT_CODE_LIST.includes(Code)) {
      console.log(Message);
    }
    // 签名失败，账号过期/不同步，需要重新登录
    if (Code === ERROR_CODES.AUTH_FAILURE) {
      QCLogin?.showLoginBox();
    }

    return { error: true, message: Message, code: Code, auditData, auditData };
  }
  if (error) {
    if (code === ERROR_CODES.NEED_LOGIN && checkLogin) {
      QCLogin?.showLoginBox();
    }
  }
  return response;
}

const reportEvent = (logTag, ext1, ext2, ext3) => {
  try {
    aegis.reportEvent({
      name: logTag,
      ext1,
      ext2,
      ext3,
    });
  } catch (err) {
    aegis.error(err);
  }
};

/*
 * 这里定义的接口都应该符合RESTFul规范
*/
export default {
  // normal method
  get(cmd, data) {
    return service.get(API_BASE_URL, {
      params: {
        Action: cmd,
        Params: {
          ...data,
        },
      },
    })
      .then(res => checkResponseStatus(res))
      .then(res => checkResponseCode(res))
      .catch(catchError);
  },
  // post request
  post({ url, cmd, data, module = 'ocr', checkLogin = true, config }) {
    // 上报日志
    reportEvent('OcrAction', module, cmd, JSON.stringify(data));
    return service.post(
      url,
      {
        module: module,
        action: cmd,
        from: 'pc',
        userAgent: navigator.userAgent,
        payload: {
          ...data
        }
      },
      config
    )
      .then(res => checkResponseStatus(res))
      .then(res => checkResponseCode(res, checkLogin))
      .catch(catchError);
  },
  demoPost({ url }) {
    return service.post(
      url,
      {
        module: 'ocr',
        from: 'cloud-demo'
      },
    )
      .then(response => {
        if (response.status === 200) {
          if (response.data.code === 0) {
            return response.data.data;
          } else {
            return { error: true, message: response.data.message };
          }
        }
      })
      .catch(catchError);
  }
};
